exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper-back {\n    position: absolute;\n    top: 50%;\n    height: 240px;\n    margin-top: -120px;\n    text-align: center;\n    left: 50%;\n    margin-left: -300px;\n}\n\n.status-code {\n    font-weight: bolder;\n    font-size: 4em;\n    vertical-align: middle;\n}\n\n.status-text {\n    font-weight: bold;\n    font-size: 3em;\n    margin-left: 10px;\n    vertical-align: middle;\n}\n\n.status-subtitle {\n    font-size: 18px;\n}\n\n.second-number {\n    font-weight: bold;\n    font-size: 2em;\n    color: #EB8D00;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/not-found/not-found.component.css
// module id = 837
// module chunks = 0